import React from 'react';

export type TrustLevel = 'high' | 'medium' | 'low';

export interface ValidationValues {
  orgId: string;
  createDate: string; // YYYY-MM-DD
  trust: TrustLevel;
}

interface Props {
  values: ValidationValues;
  onChange: (next: ValidationValues) => void;
}

const ValidationFields: React.FC<Props> = ({ values, onChange }) => {
  const handle =
    <K extends keyof ValidationValues>(key: K) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
      onChange({ ...values, [key]: e.target.value as ValidationValues[K] });

  return (
    <>
      <div className="mb-3">
        <label htmlFor="orgId" className="form-label">Org ID</label>
        <input
          id="orgId"
          type="text"
          className="form-control"
          value={values.orgId}
          onChange={handle('orgId')}
          placeholder="e.g., 12345"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="createDate" className="form-label">Create Date</label>
        <input
          id="createDate"
          type="date"
          className="form-control"
          value={values.createDate}
          onChange={handle('createDate')}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="trust" className="form-label">Trust</label>
        <select
          id="trust"
          className="form-select"
          value={values.trust}
          onChange={handle('trust')}
        >
          <option value="high">High</option>
          <option value="medium">Medium</option>
          <option value="low">Low</option>
        </select>
      </div>
    </>
  );
};

export default ValidationFields;
